<ng-template #content let-modal>
	<div class="modal-header">
	  <h3 class="modal-title guide-title">Añadir reseña</h3>
	  <button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	  </button>
	</div>
	<div class="modal-body">
	  <p>¿Cómo calificarías tu experiencia?*</p>
	  <div class="rating">
		<fa-icon *ngFor="let star of [1,2,3,4,5]" 
		  [icon]="star <= ratingProduct ? faStarSolid : faStarRegular" 
		  [class.filled]="star <= ratingProduct" 
		  style="font-size: 30px;"
		  (click)="setRatingProduct(star)">
		</fa-icon>
	  </div>
	  <p>Cuéntanos tu experiencia</p>
	  <textarea [(ngModel)]="comment" (input)="cleanEmojis($event)" maxlength="250"></textarea>
	  <span>{{comment.length}} / 250</span>
	  
	  <!-- Nuevo campo para adjuntar imagen -->
	  <div class="image-upload">
		<div class="upload-container" *ngIf="!selectedImage; else imagePreview">
		  <label for="file-upload" class="upload-label">
			<span>Cargar imagen</span>
		  </label>
		  <input id="file-upload" type="file" accept=".jpg,.jpeg,.png" (change)="onFileSelected($event)" style="display: none;">
		</div>
		<ng-template #imagePreview>
		  <div class="image-preview">
			<img [src]="selectedImage" alt="Preview">
			<button type="button" class="delete-image" (click)="removeImage()">
			  <fa-icon [icon]="faTimes"></fa-icon>
			</button>
		  </div>
		</ng-template>
	  </div>
	</div>
	<div class="modal-footer" style="justify-content: center;">
	  <button type="button" class="btn btn-review" 
		[disabled]="shouldDisableButton()"
		(click)="calificate()">Enviar calificación</button>
	</div>
  </ng-template>